import { Checkbox, Form, Input } from "antd";
import React from "react";

interface HiddenFieldsProps {}

const HiddenFields: React.FC<HiddenFieldsProps> = function (props) {
    return (
        <>
            <Form.Item noStyle hidden name="anyMatch" valuePropName="checked">
                <Checkbox />
            </Form.Item>

            <Form.Item noStyle hidden name="templateId">
                <Input />
            </Form.Item>
        </>
    );
};

export default React.memo(HiddenFields);
